import React from "react";

interface IAppointmentTypeSelectionCard {
    icon?:JSX.Element;
    cardTitle: string;
    isSelected?: boolean;
    disabled?: boolean;
    onClick?:(cardTitle: string) => void;
}

const AppointmentTypeSelectionCard = ({
  icon,
  cardTitle,
  isSelected=false,
  onClick,
  disabled=false }: IAppointmentTypeSelectionCard) => {
  const handleCardClick = ()=>{
    !disabled && onClick && onClick(cardTitle);
  };

  return (
    <div
      className={`border border-bg-taupe-50 ${!disabled ? "pt-9 bg-white cursor-pointer" : ""} rounded-lg flex flex-col
        gap-3 items-center flex-1 
    ${disabled ? "" : isSelected ?
      "!bg-gv-yellow-light border-gv-yellow" : "hover:bg-gv-yellow-light hover:border-gv-yellow"}`}
      onClick={handleCardClick}
    >
      {disabled &&
      <div className="px-4 w-full bg-gv-yellow-light text-xs text-gv-gold text-center py-1
      rounded-t-lg">Coming Soon</div>
      }
      {icon && <div className="flex items-center justify-center bg-taupe-5 rounded-full p-2 h-fit">
        {icon}
      </div>}
      <div className="px-4 pb-4 text-sm font-semibold text-center">
        {cardTitle}
      </div>
    </div>
  );
};

export default AppointmentTypeSelectionCard;
